"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionCategory = void 0;
exports.QuestionCategory = {
    BENEFITS_AND_COMPENSATION: "Benefits and Compensation",
    LEAVE_AND_TIME_OFF: "Leave and Time Off",
    POLICIES_AND_PROCEDURES: "Policies and Procedures",
    TRAINING_AND_DEVELOPMENT: "Training and Development",
    PERFORMANCE_MANAGEMENT: "Peformance Management",
    RECRUITING_AND_HIRING: "Recruiting and Hiring",
    EMPLOYEE_RELATIONS: "Employment Relations",
    HEALTH_AND_SAFETY: "Health and Safety",
    LEGAL_COMPLIANCE: "Legal and Compliance",
    EMPLOYEE_BENEFITS: "Employment Benefits",
    OTHER: "Miscellaneous",
};
